import React, {PureComponent} from "react"

import Validation from "@irati/utils/validation"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import Input from "@irati/ui/src/FormItem/Input"

interface Props extends InjectIntl {
  onChange: (value: string) => void,
  value: string
}

class Search extends PureComponent<Props> {
  searchValidationSchema = Validation.string()
    .max(50, this.props.formatMessage({id: "platform.defaultValidation.maxLength"}, {count: 50}))

  render() {
    const {onChange, value, formatMessage} = this.props
    return (
      <Input
        name="searchByName"
        label={formatMessage({id: "admin.search.textInput.label.searchByName"})}
        placeholder={formatMessage({id: "admin.search.textInput.placeholder.searchByName"})}
        onChange={onChange}
        value={value}
        flush
        validation={this.searchValidationSchema} />
    )
  }
}

export default injectIntl(Search)
